/**
 * @generated SignedSource<<c20c80bf402a0271d72e7f467a7ee86c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BillingCycle = "MONTHLY_IN_ADVANCE" | "MONTHLY_IN_ARREARS" | "ONE_TIME" | "QUARTERLY_IN_ADVANCE" | "YEARLY_IN_ADVANCE" | "%future added value";
export type EditSupplierAmountOverrideDialogSuppliersQuery$variables = Record<PropertyKey, never>;
export type EditSupplierAmountOverrideDialogSuppliersQuery$data = {
  readonly suppliers: ReadonlyArray<{
    readonly billingCycle: BillingCycle | null | undefined;
    readonly id: string;
    readonly name: string;
  }>;
};
export type EditSupplierAmountOverrideDialogSuppliersQuery = {
  response: EditSupplierAmountOverrideDialogSuppliersQuery$data;
  variables: EditSupplierAmountOverrideDialogSuppliersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Supplier",
    "kind": "LinkedField",
    "name": "suppliers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "billingCycle",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditSupplierAmountOverrideDialogSuppliersQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EditSupplierAmountOverrideDialogSuppliersQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ad0f1cb035b54fab7f8ec47126e7bf72",
    "id": null,
    "metadata": {},
    "name": "EditSupplierAmountOverrideDialogSuppliersQuery",
    "operationKind": "query",
    "text": "query EditSupplierAmountOverrideDialogSuppliersQuery {\n  suppliers {\n    id\n    name\n    billingCycle\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c50cd0a9cfb22a5cfabb388ea97359c";

export default node;
